<template>
    <div class="reminder-background">
        <div class="reminder">
            <div class="reminder__body">
                <h1>Sesja zakończy się za {{counter}} s</h1>
                <p>Po upływie tego czasu nastąpi wylogowanie. Aby przedłużyć sesję, wpisz hasło</p>
                <div class="form-group" :class="{ 'input-error': $v.password.$error }">
                    <label>Hasło do systemu</label>
                    <input class="form-control form-control-lg" type="password" v-model="password"/>
                    <labelInfo v-if="!$v.password.required" type="error" message="To pole jest wymagane"/>
                </div>
                <div class="reminder__footer">
                    <button class="button-normal button-normal--media" @click="login()">POTWIERDŹ</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue';
import { setTimeout } from 'timers';

export default {

    name: 'reminder',
    components:{

        labelInfo

    },
    mixins: [validationMixin],
    props:{

        timer:{
            type: String,
            default: '00:00'
        }

    },
    data(){

        return{

            password:'',
            counter: '',
            parsedTime: 0,

        }

    },
    validations: {

        password:{
            required,
        }

    },
    methods:{

        login(){

            this.$v.$touch();

            if (!this.$v.$invalid){

                let user = this.getDataFromStorage('user');

                let data = {
                'username': user.email,
                'password': this.password
                }

               this.$http.post('login_check', data).then(response => {

                this.badLogin = false;

                localStorage.setItem('auth_token', response.data.token);
                localStorage.setItem('refresh_token', response.data.refresh_token);

                if (localStorage.getItem('auth_token') != null){

                    this.clearStorage('sessionTimer');
                    this.$emit('confirmed');

                }

                }).catch(error => {

                    if(error.response.status === 400 || error.response.status === 401 || error.response.status === 402) {
                        
                        this.badLogin = true;
                        this.password = '';

                    }else{

                        console.error(error.response);
                        this.password = '';

                    }

                })
            
            }

        },

        countDown(){

            window.setTimeout(()=>{

                this.counter--;

                if(this.counter != 0){
                    this.countDown();
                }

                if(this.counter <= 0){
                    this.clearStorage('auth_token');
                    this.clearStorage('refresh_token');
                    this.$router.push("/");
                }

            }, 1000)

        },

    },
    mounted(){

        this.counter = parseInt(this.timer)-1;
        this.countDown();

    },

}
</script>

<style lang="scss" scoped>

.reminder-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 200;
    background:#000000a9
}

.reminder{
  background:#fff;
  border: 1px #d3020c solid;
  width: 400px;

  &__body{
    padding:30px;
    position:relative;
    display:flex;
    flex-direction: column;

    & h1{
        font-size: 14px;
    }

    & label{
        font-size: 9px;
        margin-bottom:5px;
    }

     & .form-group{
         width:100%;
     }

    & .form-group > input{
        font-size: 14px;
        color:#000000;
        opacity:1;
        font-weight: 400;
    }

    & p{
        font-size: 12px;
        color:#E3000B;
    }

  }

  &__footer{
      width:100%;
      display:flex;
      flex-direction: column;

      & button{
          margin-bottom: 15px;
          height:56px;
      }
  }
}

</style>
